/**
 * Constructor.io integration switch and project defaults.
 *
 * `indexKey` is the public Constructor.io index key. The SDK calls this value
 * `apiKey`; the adapter performs that mapping in client.js.
 *
 * Set `enabled` to false to stop initializing the lazy widget loader and to
 * prevent the Constructor.io chunks from being downloaded by the browser.
 */
export const CONSTRUCTOR_IO_CONFIG = {
  countryCode: window.cnstrc?.countryCode || '',
  enabled: true,
  indexKey: window.cnstrc?.indexKey || 'key_Sed3j5Q3AyUPwfyp',
  marketFilteringEnabled: window.cnstrc?.marketFilteringEnabled !== false,
  section: 'Products',
  clientOptions: {
    // The separately provisioned beacon owns data-attribute tracking.
    // Keep SDK event sending off to avoid duplicate behavioral events.
    sendTrackingEvents: false,
  },
  networkParameters: {
    timeout: 5000,
  },
};

/**
 * A runtime window override remains available for previews and A/B tests.
 */
export const isConstructorIOIntegrationEnabled = () => {
  const runtimeEnabled =
    typeof window !== 'undefined'
      ? window.constructorIoConfig?.enabled
      : undefined;

  return typeof runtimeEnabled === 'boolean'
    ? runtimeEnabled
    : CONSTRUCTOR_IO_CONFIG.enabled;
};

export default CONSTRUCTOR_IO_CONFIG;
